angular.
module("dx.webapp.suggestionDropdown").
directive("dxSuggestionDropdown", function dxSuggestionDropdownComponent(
) {
	"use strict";

	return {
		restrict: "E",
		scope: {},
		bindToController: {
			suggestions: "<",
			onChoose: "&",
			keydownEvent: "<",
			keyParent: "<",
			keyPrimary: "<",
			keySecondary: "<",
			keyTertiary: "<",
			maxLength: "<",
		  },
		templateUrl: "tmpl/suggestion-dropdown/suggestion-dropdown-component.html",
		controller: "DxSuggestionDropdownController",
		controllerAs: "vm",
	};
});
